import FormHelperText from "@mui/material/FormHelperText";

const ErrorList = ({ compliance }) => {
	const { errors, isCompliant, isComplianceChecked } = compliance;
	if (!isCompliant && isComplianceChecked) {
		return (
			<div>
				<FormHelperText className="mb-10" error>
					Can not ship to this address
				</FormHelperText>
				{errors?.map((error, index) => (
					<FormHelperText key={index} className="mb-10" error>
						{error.message.replace("Zip1", "Zip")}
					</FormHelperText>
				))}
			</div>
		);
	}
	return null;
};

export default ErrorList;
